// extracted by mini-css-extract-plugin
module.exports = {"root":"WhatsAppCommPreviewPopup_root__3O1HM","body":"WhatsAppCommPreviewPopup_body__16Han"};